
interface storeDTO {
  storeId?:string
  storeName?:string
  logoUrl?:string
  isFollow?:boolean
  intervalDate?: string
  lastFollowTime?:string
}
import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { getFollowStoreList, cancelFollowStore } from '@/api/industryMall'
@Component
export default class storeCollectList extends Vue {
  @Getter companyId!: string
  @Getter partnerCompanyId!: string

  refreshing = false
  loading = false
  finished = false

  storeList: storeDTO[] = []

  params = {
    pageIndex: 1,
    pageSize: 10
  }
  total = 0

  created() {
    this.getFollowStoreList()
  }
  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getFollowStoreList()
  }

  onLoad() {
    this.params.pageIndex++
    this.getFollowStoreList()
  }

  goStore(store:any) {
    this.$router.push({
      path: '/shopMallInfo',
      query: {
        storeId: store.storeId
      }
    })
  }

  /**
   * @description 获取关注店铺列表
   */
  getFollowStoreList() {
    const params = {
      partnerCompanyId: this.partnerCompanyId,
      companyId: this.companyId,
      ...this.params
    }
    getFollowStoreList(params)
      .then((res) => {
        if (this.refreshing) {
          this.storeList = []
        }
        this.total = res.data.totalRecords
        this.storeList = this.storeList.concat(res.data.records)
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(() => {
        this.finished = true
      })
      .finally(() => {
        this.loading = false
        this.refreshing = false
      })
  }

  cancelStar(store:storeDTO,index:number) {
    this.$dialog
      .confirm({
        message: '确定取消店铺关注？'
      })
      .then(() => {
        const params = {
          storeId: store.storeId,
          companyId: this.companyId
        }
        cancelFollowStore(params).then(() => {
          // this.storeList.splice(index,1)
          this.onRefresh()
        })
      })
      .catch(() => {
        console.log('取消')
      })
  }
}
